import { initForm } from './form';
import {
  isDomReady
} from './helpers';

import {
  initSections
} from './sections';

import {
  initSignForms
} from './sign-form';
import {initAnimatedImages} from "./animated-images";
import {initPhotoGalleries} from "./photo-gallery";
import {initAutoplayVideo} from "./video";
import {initHeaders} from "./header";
import {initCarousels} from "./images-carousel";
import {initPanoramas} from "./panorama";


export class Site {
  constructor() {
    this.init();
  }

  async init() {
    await isDomReady();

    await this.preload();

    await this.ready();

    document.querySelectorAll('form.wpcf7-form').forEach(element => {
      initForm(element);
    });
  }

  async preload() {
    window.dispatchEvent(new CustomEvent('vizacademy-preload-begin'));

    initSections();
    initHeaders();
    initAnimatedImages();
    initCarousels();
    initPhotoGalleries();
    initPanoramas();
    initAutoplayVideo();
    initSignForms();
    window.dispatchEvent(new CustomEvent('vizacademy-preload-end'));
  }

  async ready() {
    window.dispatchEvent(new CustomEvent('vizacademy-ready'));
  }
}
